export const SVG_XMLNS: string = 'http://www.w3.org/2000/svg';

export const LOCALHOST_HOSTNAME: string = 'localhost';
export const LOOPBACK_HOSTNAME: string = '127.0.0.1';
export const LOCALHOST_BASE_URL: string = 'http://localhost';
export const LOCALHOST_3000_URL: string = 'http://localhost:3000';
export const LOCALHOST_5173_URL: string = 'http://localhost:5173';
export const LOCALHOST_5174_URL: string = 'http://localhost:5174';
export const LOOPBACK_BASE_URL: string = 'http://127.0.0.1';
export const LOCALHOST_WILDCARD_HTTP_URL: string = 'http://localhost:*';
export const LOCALHOST_WILDCARD_WS_URL: string = 'ws://localhost:*';

export const GITHUB_HOSTNAME: string = 'github.com';
export const GITHUB_BASE_URL: string = 'https://github.com';
export const GITHUB_URL_PREFIX: string = `${GITHUB_BASE_URL}/`;
export const GITHUB_API_BASE_URL: string = 'https://api.github.com';
export const GITHUB_RAW_BASE_URL: string = 'https://raw.githubusercontent.com';
export const GITHUB_ACTIONS_OIDC_ISSUER_URL: string = 'https://token.actions.githubusercontent.com';
export const GITHUB_ACTIONS_JWKS_URL: string = `${GITHUB_ACTIONS_OIDC_ISSUER_URL}/.well-known/jwks`;
export const LVGL_EDITOR_ISSUES_URL: string = `${GITHUB_BASE_URL}/lvgl/lvgl_editor/issues`;
export const LVGL_EDITOR_NEW_ISSUE_URL: string = `${LVGL_EDITOR_ISSUES_URL}/new`;
export const LVGL_EDITOR_RELEASES_URL: string = `${GITHUB_BASE_URL}/lvgl/lvgl_editor/releases`;
export const LVGL_PRIVATE_GITHUB_PAGES_HOSTNAME: string = 'lvgl-private.github.io';

export const APPWRITE_CLOUD_ENDPOINT_URL: string = 'https://fra.cloud.appwrite.io/v1';
export const APPWRITE_CLOUD_ORIGIN_URL: string = 'https://fra.cloud.appwrite.io';
export const APPWRITE_RUN_WILDCARD_URL: string = 'https://*.appwrite.run';
export const VIEWER_API_ENDPOINT_URL: string = 'https://viewer-api.lvgl.io/v1';
export const IPIFY_API_ORIGIN_URL: string = 'https://api.ipify.org';
export const IPIFY_API_URL: string = 'https://api.ipify.org?format=json';

export const LVGL_IO_BASE_URL: string = 'https://lvgl.io';
export const LVGL_STATIC_BASE_URL: string = 'https://static.lvgl.io';
export const LVGL_IO_BLOG_URL: string = `${LVGL_IO_BASE_URL}/blog`;
export const LVGL_IO_EDITOR_CONTACT_URL: string = `${LVGL_IO_BASE_URL}/editor#contact`;

export const LVGL_PRO_PREVIEW_BASE_URL: string = 'https://lvglpro-preview.vercel.app/pro';
export const LVGL_PRO_BASE_URL: string = `${LVGL_IO_BASE_URL}/pro`;
export const LVGL_PRO_API_BASE_URL: string =
    process.env.NODE_ENV === 'production' ? LVGL_PRO_BASE_URL : LVGL_PRO_PREVIEW_BASE_URL;
export const LVGL_PRO_DOCS_URL: string = `${LVGL_IO_BASE_URL}/docs/pro`;
export const LVGL_PRO_DOWNLOAD_URL: string = `${LVGL_PRO_BASE_URL}#download`;
export const LVGL_PRO_SUPPORT_URL: string = `${LVGL_PRO_BASE_URL}/support`;
export const LVGL_PRO_TERMS_URL: string = `${LVGL_PRO_BASE_URL}/terms`;
export const LVGL_PRO_PRIVACY_URL: string = `${LVGL_PRO_BASE_URL}/privacy`;
export const LVGL_PRO_SUPPORT_CONTACT_URL: string = `${LVGL_PRO_SUPPORT_URL}#contact`;
export const LVGL_PRO_ACCOUNT_LICENSES_URL: string = `${LVGL_PRO_BASE_URL}/account#my-licenses`;
export const LVGL_PRO_DOCS_GETTING_STARTED_URL: string = `${LVGL_PRO_DOCS_URL}/introduction`;
export const LVGL_PRO_DOCS_XML_OVERVIEW_URL: string = `${LVGL_PRO_DOCS_URL}/syntax`;
export const LVGL_PRO_DOCS_XML_INDEX_URL: string = `${LVGL_PRO_DOCS_URL}`;
export const LVGL_PRO_DOCS_SUBJECTS_URL: string = `${LVGL_PRO_DOCS_URL}/syntax/data-binding`;
export const LVGL_PRO_DOCS_TRANSLATIONS_URL: string = `${LVGL_PRO_DOCS_URL}/syntax/translations`;
export const LVGL_PRO_DOCS_ANIMATIONS_URL: string = `${LVGL_PRO_DOCS_URL}/syntax/animations`;
export const LVGL_PRO_DOCS_TESTS_URL: string = `${LVGL_PRO_DOCS_URL}/syntax/testing`;
export const LVGL_PRO_DOCS_PREVIEW_URL: string = `${LVGL_PRO_DOCS_URL}/syntax/preview`;
export const LVGL_PRO_DOCS_SLOTS_URL: string = `${LVGL_PRO_DOCS_URL}/syntax/api#slots`;
export const LVGL_PRO_EDITOR_BANNER_URL: string = `${LVGL_STATIC_BASE_URL}/data/editor-banner.json`;
export const LVGL_PRO_LEGAL_ACCEPTANCE_URL: string = `${LVGL_PRO_API_BASE_URL}/api/account/legal-acceptance`;

export const LVGL_LEGAL_MANIFEST_URL: string = `${LVGL_STATIC_BASE_URL}/legal/manifest.json`;

export const VIEWER_BASE_URL: string = 'https://viewer.lvgl.io';

export const WSL_INSTALLATION_URL: string = 'https://learn.microsoft.com/en-us/windows/wsl/install';
export const EMSCRIPTEN_DOWNLOADS_URL: string = 'https://emscripten.org/docs/getting_started/downloads.html';

export const JSDELIVR_CDN_URL: string = 'https://cdn.jsdelivr.net';
export const GOOGLE_FONTS_STYLESHEET_URL: string = 'https://fonts.googleapis.com';
export const GOOGLE_FONTS_STATIC_URL: string = 'https://fonts.gstatic.com';
export const GMAIL_IMAP_HOSTNAME: string = 'imap.gmail.com';

export const DEV_SERVER_ALLOWED_ORIGINS: string[] = [LOCALHOST_5173_URL, LOCALHOST_5174_URL];

export const getAppwriteRunEndpointUrl = (endpointId: string): string => `https://${endpointId}.fra.appwrite.run`;
export const getGitHubIssueLink = (title: string, body: string): string =>
    `${LVGL_EDITOR_NEW_ISSUE_URL}?title=${title}&body=${body}`;
